<template>
  <div id="app">
    <div v-if="isLoggedIn">
      <!-- START HEADER -->
      <header id="header" class="page-topbar">
        <!-- start header nav-->
        <div class="navbar-fixed">
          <nav class="navbar-color gradiente-mpf-oscuro">
            <div class="nav-wrapper">
              <ul class="left">
                <li>
                  <h1 class="logo-wrapper">
                    <span class="brand-logo darken-1">
                      <img
                        src="images/logo/logo_firmador_blanco.png"
                        alt="Firmador de documentos MPF"
                      />
                      <span class="logo-text hide-on-med-and-down">FIRMADOR DE DOCUMENTOS</span>
                    </span>
                  </h1>
                </li>
              </ul>
              <ul class="right">
                <li>
                  <span class="hide-on-med-and-down">{{getLogUser}}</span>
                  <router-link
                    :to="{name: 'logout'}"
                    class="btn tooltipped"
                    data-position="left"
                    data-tooltip="Salir de la aplicación"
                  >
                    <i class="material-icons">exit_to_app</i>
                  </router-link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
        <!-- end header nav-->
      </header>
      <!-- END HEADER -->
    </div>
    <!-- START LEFT SIDEBAR NAV-->
    <aside v-if="isLoggedIn" id="left-sidebar-nav">
      <ul id="slide-out" class="side-nav z-depth-1 fixed leftside-navigation">
        <li class="no-padding">
          <ul class="collapsible" data-collapsible="accordion">
            <li class="bold">
              <router-link :to="{name: 'subir'}" class="waves-cyan">
                <i class="material-icons">file_upload</i>
                <span class="nav-text">Subir archivos</span>
              </router-link>
            </li>
            <li class="bold">
              <router-link :to="{name: 'firmar'}" class="waves-cyan">
                <i class="material-icons">playlist_add_check</i>
                <span class="nav-text">Firmar archivos</span>
              </router-link>
            </li>
            <li class="bold">
              <router-link :to="{name: 'descargar'}" class="waves-cyan">
                <i class="material-icons">file_download</i>
                <span class="nav-text">Descargar archivos</span>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
      <a
        href="#"
        data-activates="slide-out"
        class="sidebar-collapse btn-floating btn-medium hide-on-large-only"
      >
        <i class="material-icons">menu</i>
      </a>
    </aside>
    <!-- END LEFT SIDEBAR NAV-->

    <!-- START CONTENIDO PRINCIPAL -->
    <router-view></router-view>
    <!-- END CONTENIDO PRINCIPAL -->

    <!-- START FOOTER -->
    <footer v-if="isLoggedIn" class="gradiente-mpf">
      <div class="footer-copyright">
        <div class="container center">
          <img src="images/logo/logo_blanco.png" />
        </div>
      </div>
    </footer>
    <!-- END FOOTER -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu: [
        {
          href: { name: "subir" },
          title: "Subir Archivos",
          icon: "fa fa-user",
        },
        {
          href: { name: "firmar" },
          title: "Firmar Archivos",
          icon: "fa fa-user",
        },
        {
          href: { name: "descargar" },
          title: "Descargar Archivos",
          icon: "fa fa-user",
        },
      ],
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    getLogUser() {
      return this.$store.state.agente.name;
    },
  },
};
</script>

<style>
</style>
